import type { ClientLogo } from '@/types';

export const clientLogos: ClientLogo[] = [
  {
    id: 'liverpool',
    name: 'Liverpool',
    logo: '/clients/02_Logotipos__Liverpool.svg',
    alt: 'liverpool',
  },
  {
    id: 'prodemex',
    name: 'prodemex',
    logo: '/clients/04_Logotipos__Prodemex.svg',
    alt: 'prodemex',
  },
  {
    id: 'nestle',
    name: 'nestle',
    logo: '/clients/03_Logotipos__Nestle.svg',
    alt: 'nestle',
  },
  {
    id: 'cemex',
    name: 'cemex',
    logo: '/clients/05_Logotipos_Cemex.svg',
    alt: 'cemex',
  },
  {
    id: 'ica',
    name: 'ICA',
    logo: '/clients/07_Logotipos_ICA.svg',
    alt: 'ICA - Ingenieros Civiles Asociados',
  },
  {
    id: 'amazon',
    name: 'amazon',
    logo: '/clients/09_Logotipo_Amazon.svg',
    alt: 'amazon',
  },
  {
    id: 'copachisa',
    name: 'copachisa',
    logo: '/clients/01_Logotipos__Copachisa.svg',
    alt: 'copachisa',
  },
  {
    id: 'gia',
    name: 'gia',
    logo: '/clients/06_Logotipos_GIA.svg',
    alt: 'gia',
  },
  {
    id: 'sedena',
    name: 'sedena',
    logo: '/clients/10_Logotipo_SEDENA.svg',
    alt: 'sedena',
  },
  {
    id: 'unilive',
    name: 'unilive',
    logo: '/clients/11_Logotipo_Unilever.svg',
    alt: 'unilive',
  },

];